import { IconButton } from '@mui/material';

import SupportIcon from '../../../assets/icons/supportIcon.svg?react';

const SUPPORT_URL = 'https://t.me/ElectricGroupSupport';

export const SupportWidget = () => {
  const openSupport = () => {
    window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <IconButton
      aria-label="Open support chat on Telegram"
      onClick={openSupport}
    >
      <SupportIcon width={20} />
    </IconButton>
  );
};
